// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"ec11cafa","300":"2f20f1b7","323":"06de00f2","453":"3e3c53ec","511":"5e213596","551":"76cdf88b","595":"5c6759b1","671":"6f4913f0","679":"d7e339d8","951":"7e78d6c5"}[chunkId] + ".chunk.js";
};